import React from 'react';
import ContactCard from './ContactCard';
import AccountCard from './AccountCard';
import HoverCardTooltip from './HoverCardTooltip';

export default function ContactCardParent({ data, forWhat }) {
  if (forWhat === 'account') {
    const accountId = data?.relation_data?.account_id;
    if (accountId == null) {
      return (
        <button
          type="button"
          style={{ border: 'none', backgroundColor: '#fff' }}
        >
          {data?.name}
        </button>
      );
    }
    return (
      <HoverCardTooltip title={<AccountCard id={accountId} />}>
        <button
          type="button"
          style={{ border: 'none', backgroundColor: '#fff' }}
        >
          {data.name}
        </button>
      </HoverCardTooltip>
    );
  }

  return (
    <HoverCardTooltip title={<ContactCard id={data.id} />}>
      <button type="button" className="btn text-decoration-none p-0">
        {data.label}
      </button>
    </HoverCardTooltip>
  );
}
